import dayjs from 'dayjs';
import { TextField } from 'styles';
import { theme } from 'styles/theme/ThemeStyle';

type Props = {
	label: string;
	value: string | dayjs.Dayjs | null;
	required?: boolean;
};

const ComplaintDetailsField = ({ label, value, required = false }: Props) => {
	return (
		<TextField
			InputProps={{ readOnly: true, disableUnderline: true }}
			label={label}
			sx={{
				width: '100%',
				'& label.Mui-focused': {
					color: theme.palette.grey2.main,
				},
				'.MuiInputBase-root': {
					border: '1px solid transparent !important',
				},
			}}
			value={value}
			required={required}
		/>
	);
};

export default ComplaintDetailsField;
